import { Button, Modal, Paper, TextField } from "@mui/material";
import React from "react";

function MobileModal({isMobile, emailForUpdates, e, setEmailForUpdates, handleSignUpForUpdates}) {
    return (<Modal // hideBackdrop={{style: {backgroundColor: 'white'}}} 
  // BackdropProps={{style: {backgroundColor: 'white'}}}
  open={isMobile} style={{
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  backdropFilter: "blur(13px)"
  }}>
      <Paper sx={{
  width: 450,
  height: 330,
  bgcolor: 'background.paper',
  p: 2
  }}>
        <h2>Mobile version is comming soon!</h2> 
        <p>
          Sorry, <b><i>VocaBuddy</i></b> isn't ready for mobile yet 😿, 
          but our desktop webapp rocks 🚀!
          You can contact us for updates at:
        </p>
        <p><u>vocabuddy1@gmail.com</u></p>
        <p><b><i>And sign up for updates:</i></b></p>
        {
    /* <p>{emailForUpdates}</p> */
  }
        <TextField type="text" value={emailForUpdates} onChange={e => setEmailForUpdates(e.target.value)} placeholder="Your email" />
  
          <Button sx={{
    m: 1
  }} onClick={handleSignUpForUpdates} variant="contained">
            Update me! 😺
          </Button>
      </Paper>
  </Modal>);
  }

  export default MobileModal;